import React, {ReactNode} from 'react';

/**
 * 투입된 children을 flat하게 만든 후 valid한 react element만 걸러준다. (string, number같은 element가 아닌 값도 전부 걸러짐)
 * children에 동일한 key가 들어가는 걸 방지하기 위해, index가 포함된 key값으로 재정의되므로 투입값과 반환값이 완전 동일하지는 않음
 */
export function getValidChildren(children: ReactNode) {
  return React.Children.toArray(children).filter(Boolean);
}
